import { render, staticRenderFns } from "./SimpleResourceListWidget.vue?vue&type=template&id=42869b56&scoped=true&"
import script from "./SimpleResourceListWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleResourceListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42869b56",
  null
  
)

export default component.exports